import { ConcreteEncodable } from "./ConcreteEncodable";

import { MarketDataRequestImplEncoder } from "../../encoder/MarketDataRequestImplEncoder";

import * as CubiqTS from "../../index";
import { MarketDataRequest } from "../MarketDataRequest";

export class MarketDataRequestImpl extends ConcreteEncodable implements MarketDataRequest {
  public static enType: string = "com.bcdfx.model.MarketDataRequestImpl";

  /*FID=1*/
  public actionType: CubiqTS.ActionType;
  /*FID=2*/
  public subscriptionClass: string;
  /*FID=3*/
  public subscriptionCode: string;
  /*FID=4*/
  public tenor: CubiqTS.Tenor;
  /*FID=5*/
  public valueDate: CubiqTS.StandardDate | null = null;
  /*FID=100*/
  public messageId: string;
  /*FID=200*/
  public brokerId: string;
  /*FID=300*/
  public secureToken: CubiqTS.SecureToken | null = null;
  /*FID=999*/
  public proxySessionId: string;
  /*FID=10000*/
  public svrRxTime: CubiqTS.Long | null = null;
  /*FID=10001*/
  public svrTxTime: CubiqTS.Long | null = null;
  /*FID=10002*/
  public cliTxTime: CubiqTS.Long | null = null;
  /*FID=10003*/
  public cliRxTime: CubiqTS.Long | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = MarketDataRequestImplEncoder.Instance;
    this.setEncodableType(MarketDataRequestImpl.enType);
    this.messageId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      let r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  public toString(): string {
    return (
      "MarketDataRequestImpl[" +
      "actionType=" +
      this.actionType +
      "subscriptionClass=" +
      this.subscriptionClass +
      "subscriptionCode=" +
      this.subscriptionCode +
      "tenor=" +
      this.tenor +
      "valueDate=" +
      this.valueDate +
      "messageId=" +
      this.messageId +
      "brokerId=" +
      this.brokerId +
      "secureToken=" +
      this.secureToken +
      "proxySessionId=" +
      this.proxySessionId +
      "svrRxTime=" +
      this.svrRxTime +
      "svrTxTime=" +
      this.svrTxTime +
      "cliTxTime=" +
      this.cliTxTime +
      "cliRxTime=" +
      this.cliRxTime +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
